import { gql } from "@apollo/client";
import { SEARCH_ITEM_FIELDS } from "../fragments/searchItem";

const brandItems = gql`
  ${SEARCH_ITEM_FIELDS}
  query brandItems($brandId: ID!, $first: Int!, $after: String) {
    brandItems(brandId: $brandId, first: $first, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...SEARCH_ITEM_FIELDS
        }
        cursor
      }
    }
  }
`;
export default brandItems;
